import { render } from "./vue-qr.vue?vue&type=template&id=e75a4656"
import script from "./vue-qr.vue?vue&type=script&lang=js"
export * from "./vue-qr.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AAA-project-LK\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__